import { render, staticRenderFns } from "./FlightReservation.vue?vue&type=template&id=d0188662&scoped=true"
import script from "./FlightReservation.vue?vue&type=script&lang=js"
export * from "./FlightReservation.vue?vue&type=script&lang=js"
import style0 from "./FlightReservation.vue?vue&type=style&index=0&id=d0188662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0188662",
  null
  
)

export default component.exports